export default __webpack_public_path__ + "static/media/all-kids.6f87ba12.png";